import { render } from "./Check.vue?vue&type=template&id=5b42c3f2&scoped=true"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"

import "./Check.vue?vue&type=style&index=0&id=5b42c3f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b42c3f2"]])

export default __exports__